import { useState, useEffect } from 'react';
import axios from 'axios';
import { Flame } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * StreakBadge — insignia compacta con flama pulsante para el hero diario.
 * Trae el current_count del backend y le añade el efecto pulse-glow cuando
 * la racha está activa (>= 2 días). Silencioso si no hay racha o si la
 * preferencia del usuario oculta streaks.
 */
const StreakBadge = () => {
  const [streak, setStreak] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/streaks/me`)
      .then((res) => {
        if (!cancelled) setStreak(res.data?.streak);
      })
      .catch(() => {
        if (!cancelled) setStreak(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!streak || streak.current_count == null) return null;
  if (streak.visible === false) return null;

  const count = streak.current_count || 0;
  const active = count >= 2 && streak.status === 'active';

  return (
    <div
      className={[
        'inline-flex items-center gap-2 px-3 py-1.5 rounded-full',
        'border font-bold text-sm select-none',
        active
          ? 'bg-orange-500/15 border-orange-500/40 text-orange-300 animate-pulse-glow'
          : 'bg-slate-800 border-slate-700 text-slate-400',
      ].join(' ')}
      title={active ? `Racha activa: ${count} días` : `Sin racha activa`}
      data-testid="streak-badge"
    >
      <Flame className={`w-4 h-4 ${active ? 'text-orange-400' : 'text-slate-500'}`} />
      <span className="tabular-nums">{count}</span>
      <span className="text-[10px] uppercase tracking-wider opacity-80">
        {count === 1 ? 'día' : 'días'}
      </span>
    </div>
  );
};

export default StreakBadge;
